import React, { useEffect } from 'react';
import bgVideo from '../Assets/images/fully-customized.mp4';
import bgVideophn from '../Assets/images/fully-customizedphn.mp4';

const PixelCarousel = () => {

  useEffect(() => {
    const preloadVideo = (src) => {
      const video = document.createElement('video');
      video.src = src;
      video.preload = 'auto';
    };

    preloadVideo(bgVideo);
    preloadVideo(bgVideophn);
  }, []);

  return (
    <div className='cara-wrap'>
      <div className='pixel-carousel-container'>
        <div className='pixel-image'>
          <video autoPlay loop muted playsInline className="bg-video desktop-only">
            <source src={bgVideo} type="video/mp4" />
          </video>
          <video autoPlay loop muted playsInline className="bg-videomobile-only">
            <source src={bgVideophn} type="video/mp4" />
          </video>
        </div>
      </div>
    </div>
  );
};

export default PixelCarousel;
